/**
 *
 * @public
 */
export interface StepConfig {
  /**
   * Can be the url of the package
   */
  uses: string;
  name: string;
  props?: Record<string, unknown>;
  needs?: StepNeeds;
}
/**
 *
 * @public
 */
export interface StepNeeds {
  /**
   * name of the trigger or step
   */
  name: string;
  /**
   * if the dependency is a step, it should have an event
   */
  event?: string;
}
